import FileManager from './components/FileManager.vue';
import Vue from 'vue';
import {VueConstructor} from 'vue';
import VueDragDrop from 'vue-drag-drop';
import ActionHint from '@/directives/ActionHint';
import store from '@/store';

import './assets/fontawesome.min.css';

Vue.use(VueDragDrop);

Vue.directive('ActionHint', ActionHint);

export default {
	install(vue: VueConstructor, options: object) {
		vue.component('FileManager', FileManager);
		vue.prototype.$store = store; //register store
	}
};